import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Fingerprint2 from "fingerprintjs2";
import { UAParser } from "ua-parser-js";




function getFingerPrint(getUrlParams){

    try{

        Fingerprint2.getV18(
          {
              // refer Fingerprint2.js for details
              excludes: {
                  pixelRatio: true,
                  doNotTrack: true,
                  canvas: true,
                  webgl: true,
                  fonts: true,
                  fontsFlash: true,
                  enumerateDevices: true
              },
              preprocessor: function(key, value) {

             

                  if (key === "userAgent") {
                      let parser = new UAParser(value);
                      let userAgentMinusVersion =
                          parser.getOS().name +
                          " " +
                          parser.getOS().version +
                          ";" +
                          parser.getCPU().architecture +
                          " " +
                          parser.getBrowser().name +
                          " " +
                          parser.getEngine().name;
                      return userAgentMinusVersion;
                  }
                  return value;
              }
          },
          function(result, components) {
            sendAndProcessData( processUrlParam(getUrlParams, result) );
          }
      );
  }catch (error) {
    console.log("getFingerPrint ", error); 
    sendAndProcessData( processUrlParam(getUrlParams, "") );
  }

}


function generateUuid() {

  var today = new Date();

  var id = 'xxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });


  return today.toISOString()+id;
}

function generateErrorCode(getUrlParams){
  if(getUrlParams.has("code")){
      return " "+getUrlParams.get("code");
  }else{
    return " 01";
  }
  
}

function generateWebContent(getUrlParams) {

      console.log("***** generateWebContent -> getUrlParams",getUrlParams.get('reason'));

      let getCode = null;

      if(getUrlParams.has("code")){
          getCode = getUrlParams.get("code");
      }

      console.log("**** getCode ",getCode);
      console.log("**** android check ",getUrlParams.has("android"));
      console.log("**** ios check ",getUrlParams.has("ios"));

      //  code define from promon doc error code 
      if(getUrlParams.has("android")){
        //for android

        if(getCode == "04"){
          return "We have detected a third-party keyboard on your device, which exposes your device to security risk. To continue using AmOnline, please uninstall the third-party keyboard. \n\nKami dapati terdapat papan kekunci pihak ketiga pada peranti anda. Ini mendedahkan peranti anda kepada risiko keselamatan. Untuk terus menggunakan AmOnline, sila nyahpasang papan kekunci pihak ketiga tersebut. \n\n我们检测到您的设备上安裝了第三方键盘，这会为您的设备带来安全风险。若要继续使用 AmOnline，请卸载该第三方键盘。";
        }else if(getCode == "16" || getCode == "06" || getCode == "00" || getCode == "09"){
          return "We have detected that your device OS is modified/rooted, which exposes your device to security risk. To protect your banking credentials, access to AmOnline is blocked on this device. Please visit your authorised device service centre for assistance.\n\nKami dapati sistem operasi peranti anda telah diubah suai/”rooted”. Ini mendedahkan peranti anda kepada risiko keselamatan. Untuk melindungi maklumat perbankan anda, akses AmOnline telah disekat pada peranti ini. Sila lawati pusat servis peranti anda yang sah untuk mendapatkan bantuan.\n\n我们检测到您的设备操作系统已被修改/root，这会为您的设备带来安全风险。为了保护您的银行账户信息，此设备已被禁止使用AmOnline 。请前往授权的设备服务中心寻求帮助。";
        }else{
          return "We have detected that your device is exposed to security risk. To protect your banking credentials, access to AmOnline is blocked on this device. Please visit your authorised device service centre for assistance.\n\nKami dapati peranti anda terdedah kepada risiko keselamatan. Untuk melindungi maklumat perbankan anda, akses AmOnline telah disekat pada peranti ini. Sila lawati pusat servis peranti anda yang sah untuk mendapatkan bantuan.\n\n我们检测到您的设备存在安全风险。为了保护您的银行账户信息，此设备已被禁止使用AmOnline 。请前往授权的设备服务中心寻求帮助。";
        }


      }else if(getUrlParams.has("ios")){
        //for ios

        if(getCode == "04"){
          return "We have detected a third-party keyboard on your device, which exposes your device to security risk. To continue using AmOnline, please uninstall the third-party keyboard. \n\nKami dapati terdapat papan kekunci pihak ketiga pada peranti anda. Ini mendedahkan peranti anda kepada risiko keselamatan. Untuk terus menggunakan AmOnline, sila nyahpasang papan kekunci pihak ketiga tersebut. \n\n我们检测到您的设备上安裝了第三方键盘，这会为您的设备带来安全风险。若要继续使用 AmOnline，请卸载该第三方键盘。";
        }else if(getCode == "05"||getCode == "00"){
          return "We have detected that your device OS is modified/rooted, which exposes your device to security risk. To protect your banking credentials, access to AmOnline is blocked on this device. Please visit your authorised device service centre for assistance.\n\nKami dapati sistem operasi peranti anda telah diubah suai/”rooted”. Ini mendedahkan peranti anda kepada risiko keselamatan. Untuk melindungi maklumat perbankan anda, akses AmOnline telah disekat pada peranti ini. Sila lawati pusat servis peranti anda yang sah untuk mendapatkan bantuan.\n\n我们检测到您的设备操作系统已被修改/root，这会为您的设备带来安全风险。为了保护您的银行账户信息，此设备已被禁止使用AmOnline 。请前往授权的设备服务中心寻求帮助。";
        }else{
          return "We have detected that your device is exposed to security risk. To protect your banking credentials, access to AmOnline is blocked on this device. Please visit your authorised device service centre for assistance.\n\nKami dapati peranti anda terdedah kepada risiko keselamatan. Untuk melindungi maklumat perbankan anda, akses AmOnline telah disekat pada peranti ini. Sila lawati pusat servis peranti anda yang sah untuk mendapatkan bantuan.\n\n我们检测到您的设备存在安全风险。为了保护您的银行账户信息，此设备已被禁止使用AmOnline 。请前往授权的设备服务中心寻求帮助。";
        }



      }else{
        return "We have detected that your device is exposed to security risk. To protect your banking credentials, access to AmOnline is blocked on this device. Please visit your authorised device service centre for assistance.\n\nKami dapati peranti anda terdedah kepada risiko keselamatan. Untuk melindungi maklumat perbankan anda, akses AmOnline telah disekat pada peranti ini. Sila lawati pusat servis peranti anda yang sah untuk mendapatkan bantuan.\n\n我们检测到您的设备存在安全风险。为了保护您的银行账户信息，此设备已被禁止使用AmOnline 。请前往授权的设备服务中心寻求帮助。";

      }

}




 function processUrlParam(getUrlParams, getDeviceFingerPrint){


  let apiContent = null;
  let otherContent = "";


  if(getUrlParams.has("android")){
    apiContent = "android="+getUrlParams.get("android");
  }else if(getUrlParams.has("ios")){
    apiContent = "ios="+getUrlParams.get("ios");
  }


  if(getUrlParams.has("info")){
    otherContent += "info="+getUrlParams.get("info")+"&";
  }

  if(getUrlParams.has("pkgname")){
    otherContent += "pkgname="+getUrlParams.get("pkgname")+"&";
  }

  if(getUrlParams.has("kname")){
    otherContent += "kname="+getUrlParams.get("kname")+"&";
  }

  if(getUrlParams.has("kversion")){
    otherContent += "kversion="+getUrlParams.get("kversion")+"&";
  }

  if(getUrlParams.has("ksigner")){
    otherContent += "ksigner="+getUrlParams.get("ksigner")+"&";
  }
  

  otherContent += "finger="+getDeviceFingerPrint;

  
  console.log("urlParams",getUrlParams);


  console.log("getDeviceFingerPrint",getDeviceFingerPrint);
    

    return{
      reason: getUrlParams.get('reason'),
      manufacturer: getUrlParams.get('manufacturer'),
      model: getUrlParams.get('model'),
      shieldversion: getUrlParams.get('shieldversion'),
      api:apiContent,
      other:otherContent
    }

}


function sendAndProcessData( paramObj ) {
  console.log("*** send post");
    axios.post(process.env.REACT_APP_BASE_URL, paramObj, { 
      headers: { Authorization : "Basic YmFja2Jhc2U6YWJjZDEyMzQ=" }
    })
    .then(res => {
      console.log(res);
      console.log(res.data);
    }).catch(error => {  
      console.log("Api Call Error ", error); 
    });
}

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '');

  if (path === "/redirect/unsupportedUrl") {
    return <UnsupportedUrl />;
  }

  return <RedirectPage />;
}


function RedirectPage() {


  const urlParams = new URLSearchParams(window.location.search);

  const [userUuid, setUserUuid] = useState(generateUuid());
  const [webContent, setWebContent] = useState(generateWebContent(urlParams));
  const [errorCode, setErrorCode] = useState(generateErrorCode(urlParams));
  

  useEffect(() => {

    try{
           getFingerPrint(urlParams);
          // sendAndProcessData( processUrlParam(urlParams) );
      }catch(e){
        console.log("sendAndProcessData Error ", e); 
      }

  }, [userUuid]);

    return( 
    
    <div style={{backgroundColor: "#F5F5F5",width:"100%",height:"100%"}} >

      <div style={{paddingTop:"5%",paddingBottom:"5%",paddingLeft:"10%", width:"100%"}}>
          {/* <img src={window.location.origin + '/am-online-full.png'} alt={"amy logo"} style={{paddingLeft:"10%", height:"50px"}} /> */}
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_14479_668)">
            <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FF0000"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1475 16.4621V16.4648V23.902H13.6695V23.3056V16.4671V16.4648C13.6695 14.846 12.3742 13.5371 10.7768 13.5371C9.17494 13.5371 7.88166 14.846 7.88166 16.4648C7.88166 18.0794 9.17494 19.3889 10.7768 19.3889C11.6414 19.3889 12.4112 19.006 12.943 18.4016V23.575C12.2583 23.7842 11.5294 23.902 10.7751 23.902C6.70086 23.902 3.396 20.5679 3.396 16.4621C3.396 12.3448 6.70086 9.01221 10.7751 9.01221C14.8414 9.01221 18.1475 12.3448 18.1475 16.4621ZM16.6723 10.7559C17.9162 9.66471 19.5251 9.01221 21.2856 9.01221C25.2598 9.01221 28.4735 12.3488 28.4735 16.4586C28.4735 20.5711 25.2598 23.902 21.2856 23.902C20.9562 23.902 20.6298 23.8758 20.3151 23.8341V19.209C20.6139 19.326 20.9408 19.3851 21.2805 19.3851C22.8407 19.3851 24.1041 18.0794 24.1041 16.4648C24.1041 14.8441 22.8407 13.5336 21.2805 13.5336C20.1922 13.5336 19.2454 14.1728 18.7739 15.1054C18.5306 13.4026 17.7702 11.8849 16.6723 10.7559Z" fill="#FFFF00"/>
            </g>
            <defs>
            <clipPath id="clip0_14479_668">
            <rect width="32" height="32" fill="white"/>
            </clipPath>
            </defs>
          </svg>
      </div>

      <div style={{margin:"auto", width:"75%"}} >
      
        <div style={{textAlign:"center"}}>
          <svg width="49" height="59" viewBox="0 0 49 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7371_209)">
            <path d="M9.60803 5.33737L16.016 1.66545C16.016 1.66545 18.752 0.297484 25.472 2.72143C32.192 5.14537 41.54 14.9012 45.224 24.6809C48.908 34.4607 49.424 38.7566 46.796 47.0604C46.796 47.0604 46.58 50.3124 38.288 54.1043C38.288 54.1043 42.38 47.1684 41.444 41.8165C40.508 36.4647 40.076 28.7848 32.516 18.5011C24.956 8.2173 16.964 4.91738 9.60803 5.33737Z" fill="#F8CF4E"/>
            <path d="M19.88 58.9997C18.668 58.9997 17.252 58.4477 15.656 57.3318C15.56 57.2718 15.512 57.1638 15.5 57.0558C15.5 56.9478 15.548 56.8398 15.632 56.7678C15.692 56.7198 17.096 55.4958 16.7 52.6159C7.16003 44.984 0.248047 31.3403 0.248047 20.0966C0.248047 13.5208 2.55204 8.70886 6.74003 6.54891L14.084 2.22901C17.984 0.093055 23.084 0.633043 28.472 3.74097C39.668 10.1968 48.764 25.9645 48.764 38.8882C48.764 45.092 46.688 49.7839 42.908 52.0879L37.556 55.2078C35.012 56.6958 32.18 57.5238 29.372 57.6078C27.32 57.6678 25.604 57.4638 24.272 56.9958L21.896 58.3877C21.308 58.8077 20.648 59.0117 19.904 59.0117L19.88 58.9997ZM16.412 56.9718C18.548 58.3637 20.252 58.6397 21.476 57.7637L24.02 56.2638C24.116 56.2038 24.224 56.2038 24.332 56.2398C25.604 56.7198 27.284 56.9238 29.324 56.8758C32.012 56.8038 34.724 56.0118 37.172 54.5838L42.512 51.4639C46.064 49.3039 48.02 44.828 48.02 38.8882C48.02 26.1925 39.08 10.7128 28.088 4.36496C22.952 1.38903 18.092 0.861038 14.432 2.85299L7.08803 7.17289C3.14004 9.21285 0.968045 13.7967 0.968045 20.0966C0.968045 31.1844 7.82003 44.648 17.264 52.1239C17.336 52.1839 17.384 52.2679 17.396 52.3519C17.78 54.8838 16.916 56.3598 16.412 56.9718Z" fill="#021433"/>
            <path d="M35.756 55.4124C39.152 53.1925 41.024 48.7766 41.024 42.9807C41.024 30.285 32.084 14.7933 21.092 8.45747C15.8361 5.42154 10.9161 4.91755 7.23207 7.0535L6.87207 6.42952C10.7841 4.17357 15.9681 4.66556 21.452 7.83348C32.648 14.2893 41.744 30.057 41.744 42.9807C41.744 48.1406 40.292 52.2685 37.628 54.8244C37.172 55.2684 36.56 55.4124 36.032 55.7604L35.744 55.4124H35.756Z" fill="#021433"/>
            <path d="M21.584 38.6705L23.636 19.3869L17.144 15.643L19.076 37.2185L21.584 38.6705Z" fill="#FF0000"/>
            <path d="M20.36 40.8665C18.92 40.0385 17.756 40.6985 17.744 42.3544C17.744 44.0104 18.896 46.0144 20.336 46.8423C21.776 47.6703 22.94 47.0103 22.952 45.3544C22.952 43.6984 21.8 41.6945 20.36 40.8545V40.8665Z" fill="#FF0000"/>
            </g>
            <defs>
            <clipPath id="clip0_7371_209">
            <rect width="48.5039" height="58.0547" fill="white" transform="translate(0.248047 0.945312)"/>
            </clipPath>
            </defs>
          </svg>

          <p style={{fontWeight:700, fontSize:"18px"}}>Error code:{errorCode}</p>
          <p style={{whiteSpace: "pre-line", fontSize:"14px"}}>
              {webContent}
          </p>
        </div>
            

      </div>

    </div>
    
    );


}

function UnsupportedUrl() {
  return (
    <div style={{backgroundColor: "#F5F5F5",width:"100%",height:"100%"}} >

      <div style={{paddingTop:"5%",paddingBottom:"5%",paddingLeft:"10%", width:"100%"}}>
          {<img src={'images/RedBorder.png'} alt={"AmOnline logo"} style={{paddingLeft:"10%", height:"41px",width:"186px"}} />}
      </div>

      <div style={{margin:"auto", width:"75%"}} >
      
        <div style={{textAlign:"center"}}>
          {<img src={'images/emptyVisual.png'} style={{height:"145px",width:"245px"}} />}

          <p style={{fontWeight:700, fontSize:"20px"}}>We’re sorry, this URL is no longer available.</p>
          <p style={{whiteSpace: "pre-line", fontSize:"14px",color:"#4D4B4B"}}>
              Please visit www.ambank.com.my to access our AmOnline Web Login page.<br/><br/>For the full suite of AmOnline features and services, switch to our <br/>AmOnline App today!
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              marginTop: "20px",
              flexWrap: "nowrap"
            }}
          >
            <a
              href="https://play.google.com/store/apps/details?id=com.ambank.ambankonline&hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={"images/playstore.png"}
                alt="Google Play"
                style={{
                  height: "35px",
                  width: "119px",
                  cursor: "pointer"
                }}
              />
            </a>

            <a
              href="https://apps.apple.com/my/app/id1514166708"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={"images/appstore.png"}
                alt="App Store"
                style={{
                  height: "35px",
                  width: "106px",
                  cursor: "pointer"
                }}
              />
            </a>

            <a
              href="https://appgallery.cloud.huawei.com/marketshare/app/C101716177?locale=en_US&source=appshare&subsource=C101716177"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={"images/appgallery.png"}
                alt="Huawei AppGallery"
                style={{
                  height: "35px",
                  width: "118px",
                  cursor: "pointer"
                }}
              />
            </a>
          </div>
        </div>
            

      </div>

    </div>
  );
}



